// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2KyNY","signatureBlock":"Footer_signatureBlock__3h3iG","signature":"Footer_signature__17Col"};